import { render } from "./Pagination.vue?vue&type=template&id=4b9f5651&scoped=true"
import script from "./Pagination.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Pagination.vue?vue&type=script&charset=utf-8&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=4b9f5651&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9f5651"]])

export default __exports__